<ngx-spinner [name]="'relatorio-movimentacao-estoque'" type="ball-clip-rotate-pulse" [fullScreen]="false"
    bdColor="rgba(0, 0, 0, 0.2)"></ngx-spinner>
<mat-card>
    <mat-card-header>
        <mat-card-title>Relatório de movimentação mercadorias</mat-card-title>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content>

        <div class="row">
            <div class="col-auto">
                <mat-form-field class="example-full-width" appearance="fill">
                    <mat-label>Período</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="picker" [max]="maxDate" [min]="minDate"
                        disabled>
                        <input matStartDate formControlName="start" placeholder="Início"
                        (dateChange)="dateChanged($event)">
                        <input matEndDate formControlName="end" placeholder="Fim">
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>

                    <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Data inicial inválida
                    </mat-error>
                    <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Data final inválida</mat-error>
                </mat-form-field>
            </div>

            <div class="col-sm">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Descrição (Nome do Produto)</mat-label>
                    <input type="text" matInput [(ngModel)]="sNomeProduto" maxlength="100"
                        (keypress)="omit_special_char($event)" [matAutocomplete]="auto"
                        (ngModelChange)="onChangeNomeProduto($event)">
                    <mat-hint *ngIf="bCaracterEspecial" align="start" style="color: red;"> Não são permitidos
                        acentos ou
                        caracteres especiais </mat-hint>
                </mat-form-field>
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let prod of produtos" [value]="prod.Nome"
                        (onSelectionChange)="selecionarProduto(prod)">
                        {{prod.Nome}}
                    </mat-option>
                </mat-autocomplete>
            </div>

            <div class="col-2">
                <button class="mt-4" mat-flat-button color="primary" (click)="buscarRelatorioMovimentacaoPeriodo()">
                    <mat-icon>search</mat-icon> Buscar
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>